export default {"src":"/customer-services/_next/static/media/email.57854f90.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};